"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VIEW_TYPE = exports.ALIGNMENT_MAP = void 0;
var VIEW_TYPE = exports.VIEW_TYPE = {
  "default": 'default',
  pill: 'pill',
  splash: 'splash',
  classic: 'classic'
};
var ALIGNMENT_MAP = exports.ALIGNMENT_MAP = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var _default = exports["default"] = {
  VIEW_TYPE: VIEW_TYPE
};